import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="self-assessment-document"
export default class extends Controller {
  connect() {
  }
}
